<template>
  <div class="container">
      <LoadingSpinner :loading="loading"> </LoadingSpinner>

      <div class="mt-4" style="max-width:545px">
        <h3>Generate eventReports for Z-reports</h3>

        <div v-if="!loading">
            <div v-if="hasMultiLocations()" class="mt-4">
              <span class="ingredient-title">Velg avdeling</span>
              <select class="form-select" v-model="locationId" @change="showTerminals()">
                <option v-for="(location, index) in locations" :key="index" :value="location.id">{{ location.name }}</option>
              </select>
            </div>

            <div v-if="terminals.length > 0">
                <SelectTerminal :terminals="terminals" :terminal="selectedTerminal" @setSelectedTerminal="setSelectedTerminal"/>

                <SelectDate ref="selectDateFrom" label="Velg fra og med dato"/>
                <SelectDate ref="selectDateTo" label="Velg til og med dato"/>

                <button type="button" class="bo_btn mt-3" :class="resultFetched ? 'mb-3' : 'mb-0'" @click="generateEventReports"> Generate eventReport for Z-reports </button>

                <div v-if="resultFetched" class="xz-report">
                  <p class="no-report-found">{{ resultMessage }}</p>
                </div>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
  import LoadingSpinner from "@/components/other/LoadingSpinner";
  import SelectDate from "@/components/other/SelectDate";
  import ReportService from "@/services/report/ReportService";
  import LocationUtil from "@/util/LocationUtil";
  import TerminalService from "@/services/terminal/TerminalService";
  import SelectTerminal from "@/components/report/SelectTerminal";

  export default {
    components: {LoadingSpinner, SelectTerminal, SelectDate},
    data() {
      return {
        loading: true,

        locationId: '',
        locations: [],
        merchant: '',
        terminals: [],
        selectedTerminal: {},
        resultFetched: false,
        resultMessage: ''
      };
    },
    mounted() {
      ReportService.getDataForReportGui().then(
          (response) => {
            let dataForGui = response.data;
            this.merchant = dataForGui.merchant;
            this.locations = dataForGui.locations;

            this.locationId = this.locations.length ? this.locations[0].id : '';

            this.showTerminals();
          },
          (error) => {
            console.log(error);
          }
      );
    },
    methods: {
      hasMultiLocations(){
        return LocationUtil.hasMultiLocations();
      },
      showTerminals() {
        this.loading = true;
        this.resultFetched = false;

        TerminalService.getTerminalsForLocation(this.locationId).then(
            (response) => {
              let filteredTerminals = [];

              let availableTerminals = response.data;
              for(let i = 0; i < availableTerminals.length; i++) {
                let terminal = availableTerminals[i];
                if(terminal.terminalType !== 'KDS'){
                  filteredTerminals.push(terminal);
                }
              }

              this.terminals = filteredTerminals;
              this.selectedTerminal = this.terminals.length > 0 ? this.terminals[0] : {};

              this.loading = false;
            },
            (error) => {
              console.log(error);
            }
        );
      },
      setSelectedTerminal(terminal){
        this.selectedTerminal = terminal;
        this.resultFetched = false;
      },
      generateEventReports() {
        this.loading = true;
        let fromDate = this.$refs.selectDateFrom.getSelectedDate();
        let toDate = this.$refs.selectDateTo.getSelectedDate();

        ReportService.generateEventReports(this.locationId, this.selectedTerminal.id, fromDate, toDate).then(
            (response) => {
              let count = response.data;
              if (count === 'FAILED') {
                this.resultMessage = 'Generering feilet. Sjekk loggene for detaljer.';
              } else {
                this.resultMessage = 'Generert ' + count + ' eventReports for Z-rapporter.';
              }

              this.loading = false;
              this.resultFetched = true;
            },
            (error) => {
              console.log(error);
              this.loading = false;
              this.resultFetched = true;
              this.resultMessage = 'En feil oppstod. Prøv igjen.';
            }
        );
      }
    }
  };
</script>
